import { motion } from "framer-motion";

export default function Section({
  id,
  title,
  subtitle,
  number,
  children,
  className = "",
  dark = false,
}) {
  return (
    <section
      id={id}
      className={`py-20 md:py-28 relative ${
        dark
          ? "bg-app-panel/50 backdrop-blur-sm"
          : "bg-transparent"
      } ${className}`}
    >
      {/* Subtle section divider line */}
      {dark && (
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-app-border to-transparent" />
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {title && (
          <div className="text-center mb-14 md:mb-20">
            {/* Section number */}
            {number && (
              <motion.p
                className="font-mono text-xs font-medium text-app-accent/60 tracking-[0.2em] uppercase mb-3"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
              >
                {number} ──
              </motion.p>
            )}

            <motion.h2
              className="font-display text-3xl md:text-[2.6rem] font-bold text-app-text leading-tight mb-4"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              {title}
            </motion.h2>

            {subtitle && (
              <motion.p
                className="text-app-mute text-base md:text-lg max-w-2xl mx-auto leading-relaxed"
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                {subtitle}
              </motion.p>
            )}

            {/* Animated accent bar */}
            <motion.div
              className="flex items-center justify-center gap-2 mt-6"
              initial={{ opacity: 0, scaleX: 0 }}
              whileInView={{ opacity: 1, scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="h-px w-12 rounded-full bg-app-border" />
              <div
                className="h-1 w-16 rounded-full"
                style={{
                  background: "linear-gradient(90deg, #3fa9f5, #a78bfa)",
                }}
              />
              <div className="h-px w-12 rounded-full bg-app-border" />
            </motion.div>
          </div>
        )}
        {children}
      </div>

      {dark && (
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-app-border to-transparent" />
      )}
    </section>
  );
}
